export default __webpack_public_path__ + "static/media/ricks.e993242d.png";